import { render, staticRenderFns } from "./NoEmailAssigned.vue?vue&type=template&id=11eb80d2"
import script from "./NoEmailAssigned.vue?vue&type=script&lang=js"
export * from "./NoEmailAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports